export class BypassAuthGroupInfo {
  group1Days: number;
  group2Days: number;
  group3Days: number;
  group4Days: number;
  group1Emails: string;
  group2Emails: string;
  group3Emails: string;
}
